import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { QuicktipsPosition } from 'src/app/constant/quicktips.position';
import { SpriteConstant } from 'src/app/constant/sprite.constant';
import { UserService } from 'src/app/services/user.service';
import { UtilService } from 'src/app/util/UtilService';

@Component({
    selector: 'BetLimitpopUpComponent',
    templateUrl: '../template/betlimitpopup.component.html',
    styleUrls: ['../css/betlimitpopup.component.css'],
    standalone: false
})
export class BetLimitPopupComponent implements OnInit {
  @Input() data;
  lang = 'en';
  @Output() redirectEmit: EventEmitter<any> = new EventEmitter<any>();
  public betLimitDesktop;
  public optionOver = -1;
  public scaleR;
  public betLimits;
  public isportrait;
  public layout;
  isMenuLoaded = false;
  common_icons: any;
  menu_icons: any;
  public _subscriptionScale: any;
  constructor(
    public _utilService: UtilService,
    public userService: UserService
  ) {}
  /* @HostListener('window:resize') onResize() {
    //console.log('this.data.scaleR---------------->this.data.scaleR',this.data.scaleR);
  } */
  ngOnInit() {
    this._subscriptionScale = this._utilService.scaleChange.subscribe(
      (value) => {
        //console.log('this.data.scaleR---------------->_subscriptionScale',value);
        let windowHeight =
          this._utilService.parentHeight != 0
            ? this._utilService.parentHeight
            : window.innerHeight;
        this.isportrait = window.innerWidth > windowHeight ? false : true;
        //console.log('_subscriptionScale');
        //console.log(value);
        this.scaleR = value;
        this.isMenuLoaded = this.userService.user.isMenuLoaded;
        //console.log('this.isMenuLoaded',this.isMenuLoaded);
      }
    );
    this.menu_icons = SpriteConstant.MENU_ICONS;
    this.common_icons = SpriteConstant.COMMON_ICONS;
    /*   data----------->
     let messageObj: any = {};
   messageObj.tableid_QueuedUser = tableid_QueuedUser;
   messageObj.betLimits = [...tableLimit_QueuedUser];
   messageObj.lang = this.language;
   messageObj.scaleR = this.scaleR;
   messageObj.isPopUpVisible  = this.isPopUpVisible;
   messageObj.isportrait = (this.utilService.viewMode == View.PORTRAIT)?true:false; */
    this.data.tableid_QueuedUser[0];
    //console.log('betLimits---------------->BetLimitPopupComponent',this.data.lang,this.data.betLimits,this.data.tableid_QueuedUser[0]);
    if (this.data.lang) {
      this.languageChange(this.data.lang);
      this.lang = this.data.lang;
    }
    if (this.data.scaleR) {
      this.scaleR = this.data.scaleR;
    }
    if (this.data.betLimits) {
      this.betLimits = this.data.betLimits;
    }
    if (this.data.isportrait) {
      this.isportrait = this.data.isportrait;
    }
    if (this.data.isMenuLoaded) {
      this.isMenuLoaded = this.data.isMenuLoaded;
      //console.log('this.isMenuLoaded',this.isMenuLoaded);
    }
  }
  OnChangesEvent(data) {
    //console.log('this.data.scaleR---------------->this.data.scaleR',this.data.scaleR);
    if (this.data.scaleR) {
      this.scaleR = this.data.scaleR;
    }
  }
  languageChange(lang) {
    this.betLimitDesktop = QuicktipsPosition[lang];
  }

  onOptionSelect = (optionValue) => {
    //console.log("optionValue",optionValue)
    let tableLimitObj: any = {};
    tableLimitObj.optionValue = optionValue;
    tableLimitObj.tableid_QueuedUser = this.data.tableid_QueuedUser[0];
    this.redirectEmit.next(tableLimitObj);
  };
  onOptionOver = (optionValue) => {
    //console.log("optionValue",optionValue)
    this.optionOver = optionValue;
  };
  onOptionOut = (optionValue) => {
    this.optionOver = -1;
  };
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this._subscriptionScale) {
      this._subscriptionScale.unsubscribe();
    }
    delete this._subscriptionScale;
    delete this.lang;
    delete this.scaleR;
    delete this.betLimits;
    delete this.betLimitDesktop;
    delete this.optionOver;
    delete this.betLimitDesktop;
    delete this.optionOver;
    delete this.scaleR;
    delete this.betLimits;
    delete this.isportrait;
    delete this.layout;
  }
}
